export const shareableLinkParam = 'copied_link';

export enum ShareMethod {
  email = 'sharing-email',
  copyLink = 'copying-link',
}
